var styleDataHash = "fefdf74a";
const injectCss = (() => {
  var css = `@charset "UTF-8";.-VW-M,.ReactModalPortal,._8FAYS,.glob_fontElementMap,button{font-family:var(--ricos-font-family,unset)}.Ea0qz{display:flex}.vTtfa:hover{box-shadow:0 0 0 2px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}.fGkYP,.vTtfa:hover{border-radius:var(--ricos-native-whitebox-border-radius,0);cursor:default}.fGkYP{box-shadow:0 0 0 1px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}.XBbAQ .fGkYP{box-shadow:none!important}.Jy1xY{cursor:move;display:block;height:100%;left:0;position:absolute;top:0;width:100%}.Jy1xY.ju6A8{pointer-events:none}.kduPy ::selection{background:transparent}.tDPR9{display:none}.-VW-M{position:relative}.pRM0o{max-width:100%}.ReactModal__Body--open{overflow-y:hidden}.ReactModal__Content{direction:ltr;font-weight:300}.ReactModalPortal{color:var(--ricos-settings-text-color,#333)}.ReactModalPortal,.ReactModalPortal input{font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif)}.b8oTz{color:#333;text-decoration:none}.uh22X{display:block}.Amxlc{position:relative}._39Iv0{margin-left:-20px;margin-right:-20px;overflow-x:auto;overflow-y:hidden}._39Iv0.nrfa1::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.5)}._39Iv0.nBDGK::-webkit-scrollbar-thumb{background-color:transparent}.xzgzh{max-width:max-content!important;min-width:100%}._39Iv0::-webkit-scrollbar{-webkit-appearance:none}._39Iv0::-webkit-scrollbar-thumb{border:2px solid #fff;border-radius:8px}._39Iv0::-webkit-scrollbar:horizontal{height:10px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var general_default = {
  "fontElementMap": "_8FAYS",
  "pluginContainer": "-VW-M",
  "flex": "Ea0qz",
  "isFocusable": "vTtfa",
  "hasFocus": "fGkYP",
  "dragImageView": "XBbAQ",
  "overlay": "Jy1xY",
  "noPointerEventsOnFocus": "ju6A8",
  "hideTextSelection": "kduPy",
  "hidden": "tDPR9",
  "pluginContainerMobile": "pRM0o",
  "isImage": "b8oTz",
  "anchor": "uh22X",
  "horizontalScrollbarWrapper": "Amxlc",
  "pluginWithHorizontalScrollbar": "_39Iv0",
  "show": "nrfa1",
  "hide": "nBDGK",
  "horizontalScrollbar": "xzgzh"
};
export {
  general_default as default,
  injectCss
};
//# sourceMappingURL=general-scss.js.map
